import { pick } from 'lodash';
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '..';
import { minifyJS } from '../../utils/minifyJS';

const selectExpressionsRaw = (state: RootState) => state.site.expressions;

function buildExpressionsCollection(
  expressions: RootState['site']['expressions'],
  names?: string[]
) {
  const selected = !names?.length ? expressions : pick(expressions, names);
  const fnCollection: Record<string, Function> = {};
  for (const expObj of Object.values(selected)) {
    const expStr = minifyJS(expObj.value);
    const args =
      expObj.variables
        ?.split(/\s*[,;]\s*/)
        .filter(item => item.trim() !== '')
        .join(', ') || '';
    try {
      // eslint-disable-next-line @typescript-eslint/no-implied-eval
      const fn = new Function(args, expStr);
      fnCollection[expObj.name] = fn;
    } catch (error) {
      console.error(`Function creation by expression "${expObj.name}" error`, error);
    }
  }
  return fnCollection;
}

export const selectExpressions = createSelector(
  [selectExpressionsRaw, (_state: RootState, names?: string[]) => names],
  buildExpressionsCollection
);
